import { render, staticRenderFns } from "./relation_fine_group.vue?vue&type=template&id=16087958&scoped=true"
import script from "./relation_fine_group.vue?vue&type=script&lang=js"
export * from "./relation_fine_group.vue?vue&type=script&lang=js"
import style0 from "./relation_fine_group.vue?vue&type=style&index=0&id=16087958&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16087958",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16087958')) {
      api.createRecord('16087958', component.options)
    } else {
      api.reload('16087958', component.options)
    }
    module.hot.accept("./relation_fine_group.vue?vue&type=template&id=16087958&scoped=true", function () {
      api.rerender('16087958', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm/views/activity/marketing_reconsideration/components/relation_fine_group.vue"
export default component.exports